import React from 'react'
import { Grid } from '@material-ui/core'

import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

import {
  Checkbox,
  Tooltip,
} from 'ui/components'

import { PANEL_ENVS } from 'utils/constants/environments'

export default ({ docType, onChange, withOnlyPeps, withUnusedServices }) => {
  const renderCheckboxOnlyPep = () => {
    if (docType === PANEL_ENVS.CNPJ) return null

    return (
      <Checkbox
        label="Filtrar apenas consultas com PEP"
        value={withOnlyPeps}
        onClick={(checked) => onChange('with_only_peps', checked)}
      />
    )
  }

  const renderCheckboxUnusedServices = () => {
    return (
      <Grid container item xs={12}>
        <Grid item xs={10}>
          <Checkbox
            label="Incluir serviços desconsiderados"
            value={withUnusedServices}
            onClick={(checked) => onChange('with_unused_services', checked)}
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip
            leaveDelay={800}
            title={(
              <React.Fragment>
                <h3 color="inherit">Serviços desconsiderados</h3>
                <div>
                  <p>
                    Um serviço é classificado como desconsiderado quando seu valor não é levado em conta, pois com os valores dos outros serviços já é possível decidir o status final da consulta (aprovado ou reprovado).
                  </p>
                  <p>
                    Será exibido no lugar dos dados do serviço a palavra
                    <strong> DESCONSIDERADO</strong>
                    .
                  </p>
                </div>
              </React.Fragment>
            )}
          >
            <HelpOutlineIcon />
          </Tooltip>
        </Grid>
      </Grid>
    )
  }

  const renderGrid = () => {
    return (
      <React.Fragment>
        <Grid item xs={12} sm={4}>
          <p>Serviços</p>
        </Grid>

        <Grid item xs={12} sm={8}>
          {renderCheckboxOnlyPep()}
          {renderCheckboxUnusedServices()}
        </Grid>
      </React.Fragment>
    )
  }

  return (
    renderGrid()
  )
}
